export const InboxIcons = () => (
  <svg
    aria-hidden="true"
    width="0"
    height="0"
    style={{ position: "absolute", overflow: "hidden" }}
  >
    <symbol id="i-sparkles" viewBox="0 0 24 24">
      <path d="m12 3 1.1 3.4a4 4 0 0 0 2.5 2.5L19 10l-3.4 1.1a4 4 0 0 0-2.5 2.5L12 17l-1.1-3.4a4 4 0 0 0-2.5-2.5L5 10l3.4-1.1a4 4 0 0 0 2.5-2.5L12 3Z" />
      <path d="m19 16 .5 1.5A2.3 2.3 0 0 0 21 19l-1.5.5A2.3 2.3 0 0 0 18 21l-.5-1.5A2.3 2.3 0 0 0 16 18l1.5-.5A2.3 2.3 0 0 0 19 16Z" />
    </symbol>
    <symbol id="i-search" viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.2-3.2" />
    </symbol>
    <symbol id="i-bot" viewBox="0 0 24 24">
      <rect x="4" y="7" width="16" height="12" rx="4" />
      <path d="M9 12h.01M15 12h.01M9 16h6M12 7V4M10 4h4" />
    </symbol>
    <symbol id="i-user" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        stroke="none"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      />
    </symbol>
    <symbol id="i-users" viewBox="0 0 24 24">
      <path d="M16 20a6 6 0 0 0-12 0M10 11a4 4 0 1 0 0-8" />
      <path d="M18 8a3 3 0 0 1 0 6M20 20a5 5 0 0 0-3.2-4.7" />
    </symbol>
    <symbol id="i-briefcase" viewBox="0 0 24 24">
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2" />
    </symbol>
    <symbol id="i-phone" viewBox="0 0 24 24">
      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7A2 2 0 0 1 22 16.9Z" />
    </symbol>
    <symbol id="i-coins" viewBox="0 0 24 24">
      <ellipse cx="12" cy="6" rx="7" ry="3" />
      <path d="M5 6v4c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 10v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4M5 14v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4" />
    </symbol>
    <symbol id="i-map" viewBox="0 0 24 24">
      <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </symbol>
    <symbol id="i-clock" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </symbol>
    <symbol id="i-more" viewBox="0 0 24 24">
      <circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" />
    </symbol>
    <symbol id="i-panel" viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M15 4v16" />
    </symbol>
    <symbol id="i-check" viewBox="0 0 24 24">
      <path d="m5 12 4 4L19 6" />
    </symbol>
    <symbol id="i-lock" viewBox="0 0 24 24">
      <rect x="5" y="10" width="14" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </symbol>
    <symbol id="i-send" viewBox="0 0 24 24">
      <path d="m22 2-7 20-4-9-9-4Z" />
      <path d="M22 2 11 13" />
    </symbol>
    <symbol id="i-paperclip" viewBox="0 0 24 24">
      <path d="m21.4 11.6-8.8 8.8a6 6 0 0 1-8.5-8.5l9.5-9.5a4 4 0 0 1 5.7 5.7l-9.6 9.6a2 2 0 0 1-2.8-2.8l8.8-8.8" />
    </symbol>
    <symbol id="i-smile" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" />
    </symbol>
    <symbol id="i-note" viewBox="0 0 24 24">
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" />
      <path d="M14 3v6h6M8 13h8M8 17h6" />
    </symbol>
    <symbol id="i-calendar" viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M16 3v4M8 3v4M3 10h18" />
    </symbol>
    <symbol id="i-tag" viewBox="0 0 24 24">
      <path d="M20 12 12 20 4 12V4h8Z" />
      <circle cx="8.5" cy="8.5" r="1.3" />
    </symbol>
    <symbol id="i-arrow" viewBox="0 0 24 24">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </symbol>
    <symbol id="i-chevron" viewBox="0 0 24 24">
      <path d="m9 18 6-6-6-6" />
    </symbol>
    <symbol id="i-filter" viewBox="0 0 24 24">
      <path d="M4 5h16M7 12h10M10 19h4" />
    </symbol>
  </svg>
);
